import { render, staticRenderFns } from "./IBDashboard.vue?vue&type=template&id=7317ff04&scoped=true"
import script from "./IBDashboard.vue?vue&type=script&lang=js"
export * from "./IBDashboard.vue?vue&type=script&lang=js"
import style0 from "./IBDashboard.vue?vue&type=style&index=0&id=7317ff04&prod&lang=scss&scoped=true"
import style1 from "./IBDashboard.vue?vue&type=style&index=1&id=7317ff04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7317ff04",
  null
  
)

export default component.exports